module.exports = "../../../../platform/assets/pageMainIcon/icon-tongyong-1-green.svg";